<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tAEXN6/tc-custom/9781459234871.jpg?1740865392680" alt="This image is the cover for the book Reluctant Heiress, Lone Star Legacy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Reluctant Heiress, Lone Star Legacy
      </h1>
      <p class="bookDescription body article font2">
        <p>The illegitimate daughter of a late Texas billionaire, Sophia Rivers stands to inherit a fortune. But the stubborn woman doesn't want a penny of it. As financial advisor to the wealthy Delaney family, Garrett Cantrell has to convince Sophia to accept her inheritance. If she doesn't, her half brothers will lose their billions. So he introduces himself as a local businessman and starts softening her up, talking to her about family, loyalty and love. But the proud beauty has no idea who he really is. And the truth may cost him his heart.<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sara Orwig
      </h2>
      
      <p class="authorDescription body article">Sara Orwig lives in Oklahoma and has a deep love of Texas. With a master&rsquo;s degree in English, Sara taught high school English, was Writer-in-Residence at the University of Central Oklahoma and was one of the first inductees into the Oklahoma Professional Writers Hall of Fame. Sara has written mainstream fiction, historical and contemporary romance. Books are beloved treasures that take Sara to magical worlds. She loves both reading and writing them.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?66f1fd52